import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PageMeta } from "@/components/common/PageMeta";
import { AboutHero } from "@/components/about/AboutHero";
import { StorySection } from "@/components/about/StorySection";
import { BeliefsSection } from "@/components/about/BeliefsSection";
import { TeamFullSection } from "@/components/about/TeamFullSection";
import { MilestonesSection } from "@/components/about/MilestonesSection";
import { CareersSection } from "@/components/about/CareersSection";
import { AboutClosingCTA } from "@/components/about/AboutClosingCTA";

export function AboutPage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          const topnavHeight = parseInt(
            getComputedStyle(document.documentElement).getPropertyValue("--topnav-height") || "64",
            10,
          );
          const top = el.getBoundingClientRect().top + window.scrollY - topnavHeight - 16;
          window.scrollTo({ top, behavior: "smooth" });
        }
      }, 100);
      return () => clearTimeout(t);
    }
  }, [location.hash]);

  return (
    <>
      <PageMeta
        title="About COSX | COSX"
        description="The team behind COSX. Built by operators from regulated fintech. Building AI agents for immigration law, education, and investment management."
        path="/about"
      />

      <AboutHero />
      <StorySection />
      <BeliefsSection />
      <TeamFullSection />
      <MilestonesSection />
      <CareersSection />
      <AboutClosingCTA />
    </>
  );
}
